import axios from 'axios';
import { Message } from 'view-design';
import config from '@/config';
import router from '@/router';
import { getCookies, removeCookies } from '@/utils/helper';

const service = axios.create({
    baseURL: config.apiUrl + '/a',
    timeout: 60000 // 请求超时时间
})

// 存储正在进行的请求
const pendingRequests = new Map();

service.interceptors.request.use(
    config => {
        // 生成请求唯一标识（URL + method）
        const requestKey = `${config.method}_${config.url}_${JSON.stringify(config.params || {})}_${JSON.stringify(config.data || {})}`;
        
        // 如果存在相同请求，直接拒绝
        if (pendingRequests.has(requestKey)) {
            return Promise.reject({ 
                code: 'DUPLICATE_REQUEST', 
                message: '请勿重复点击' 
            });
        }
        
        // 标记请求开始
        pendingRequests.set(requestKey, true);
        config.requestKey = requestKey;
        
        const token = getCookies('p_c_access_token')
        if (token) {
            config.headers['p-c-access-token'] = token
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
)

service.interceptors.response.use(
    response => {
        // 请求完成，移除记录
        if (response.config.requestKey) {
            pendingRequests.delete(response.config.requestKey);
        }
        
        let status = response.data ? response.data.code * 1 : 0
        const code = status
        switch (code) {
            case 200:
                return response.data
            case 401:
            case 400:
                return Promise.reject(response.data || { 'msg': '未知错误' })
            case 400011:
            case 500:
            case 400012:
                return Promise.reject({ msg: '系统异常' })
            case 410000:
            case 410001:
            case 410002:
                localStorage.clear()
                removeCookies('p_c_access_token')
                router.replace({ path: '/' })
                break
            default:
                break
        }
    },
    error => {
        // 请求失败，移除记录
        if (error.config && error.config.requestKey) {
            pendingRequests.delete(error.config.requestKey);
        }
        
        // 忽略重复请求的提示
        if (error.code === 'DUPLICATE_REQUEST') {
            return Promise.reject(error);
        }
        
        if (typeof error.response == "undefined") {
            Message.error("服务器异常");
        }
        return Promise.reject(error);
    }
)

export default service;